import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { PayService } from '../services/pay.service';
import { ContactPayshapAccountService } from '../services/contact-payshap-account.service';
import { finalize } from 'rxjs/operators';
import { SessionService } from '../services/session.service';
import { ContactService } from '../services/contact.service';
@Component({
  selector:'app-pay',
  standalone:true,
  imports:[CommonModule,
  FormsModule,
  MatAutocompleteModule,
  MatInputModule],
  template:`
     <div class="spinner-container" *ngIf="isLoadingPageContent">
      <span class="spinner"></span>
    </div>
    <div *ngIf="showPageContent">
      <!--PAYMENT METHODS -->
      <div *ngIf="showPaymentMethods">
        <div class="section-title">
          Select payment method
        </div>
        <div class="category-option" *ngFor="let p of paymentMethods"
          [class.selected]="selectedPaymentMethod === p"
          (click)="selectPaymentMethod(p)">
          <div class="payment-option-left">
            <span>{{ p.name }}</span>
          </div>
          <img [src]="'assets/images/' + p.logo" class="payment-option-logo">
        </div>
      </div>

      <div *ngIf="showBeneficiarySection">
        <div *ngIf="!selectedContact && !showAddNewContact">
          <div class="back-btn" (click)="return('paymentMethods')">
            ←
          </div>
          <div class="title">Select beneficiary</div>
          <!-- ADD CONTACT BUTTON -->
          <div class="edit-only-top-bar" >
            <div class="top-actions">
              <button class="icon-btn " (click)="onAddNewContact()">
                <span class="icon-text">+</span>
              </button>
            </div>
          </div>

          <!-- CONTACT SEARCH INPUT -->
          <div class="search-box">
            <input class="search-input"
                  placeholder="Search beneficiary"
                  [(ngModel)]="searchInput">
            <span class="search-icon">⌕</span>
          </div>
          <!-- CONTACTS LIST-->
          <div class="pay-scroll">
            <div class="table-list">
              <div class="row"
                  *ngFor="let c of filteredContacts()"
                  (click)="selectContact(c)">
                <div class="contact-details">
                  <strong class="tx-title">
                    {{c.name}}
                  </strong>
                  <small class="tx-number">
                    {{c.displayNumber}}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ADD CONTACT -->
        <div *ngIf="showAddNewContact">
          <div class="back-btn"
              (click)="closeAddNewContact()">
            ←
          </div>
          <div class="section-title">New Beneficiary</div>
            <div>
              <!-- NAME -->
              <label class="field-label">Name</label>
              <input class="input"
                placeholder="Enter name"
                [(ngModel)]="newContactName"
                (ngModelChange)="contactNameValidationMessage=''">
              <div class="validation-message" *ngIf="contactNameValidationMessage">
                {{contactNameValidationMessage}}
              </div>

              <!-- WHATSAPP NUMBER -->
              <label class="field-label">WhatsApp Number</label>
              <div class="phone-input">
                <div class="phone-flag">
                  <img src="assets/images/sa-flag.png" class="flag-img">
                </div>
                <input
                class="phone-number-input"
                type="text"
                inputmode="numeric"
                maxlength="10"
                placeholder="Enter WhatsApp number"
                [(ngModel)]="newContactNumber"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onNewContactPhoneInput($event)">
              </div>
              <div class="validation-message" *ngIf="contactWhatsappNumberValidationMessage">
                {{contactWhatsappNumberValidationMessage}}
              </div>
              <label class="save-beneficiary">
                <input type="checkbox" [(ngModel)]="saveContact">
                Save beneficiary
              </label>
            </div>
            <!-- BUTTONS -->
            <div class="btns mt-20px">
              <button class="set-authorization-btn"
                (click)="addNewContact()"
                [disabled]="isLoading || !newContactName || !whatsappNumberValid">
                <span *ngIf="!isLoading">Add</span>
                <span *ngIf="isLoading" class="spinner"></span>
              </button>
          </div>
        </div>
      </div>

      <!-- PAYSHAP -->
      <div *ngIf="showPayshapSection">
        <div *ngIf="!selectedPayshapAccount && !showAddNewPayshapAccount">
          <div class="back-btn" (click)="return('beneficiaries')">
            ←
          </div>
          <div class="title">Select Bank Account</div>
          <!-- ADD PAYSHAP ACCOUNT BUTTON -->
          <div class="edit-only-top-bar" >
            <div class="top-actions">
              <button class="icon-btn " (click)="onAddNewPayshapAccount()">
                <span class="icon-text">+</span>
              </button>
            </div>
          </div>

          <!-- PAYSHAP ACCOUNT SEARCH INPUT -->
          <div class="search-box">
            <input class="search-input"
                  placeholder="Search bank account"
                  [(ngModel)]="searchInput">
            <span class="search-icon">⌕</span>
          </div>
          <!-- PAYSHAP ACCOUNT LIST-->
          <div class="pay-scroll">
            <div class="table-list">
              <div class="row"
                  *ngFor="let c of filteredPayshapAccounts"
                  (click)="selectPayshapAccount(c)">
                <div class="contact-details">
                  <strong class="tx-title">
                    {{c.bankName}}
                  </strong>
                  <small class="tx-number">
                    {{c.accountNumber}}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ADD PAYSHAP ACCOUNT -->
        <div *ngIf="showAddNewPayshapAccount">
          <div *ngIf="showSelectBank">
            <div class="back-btn" (click)="closeAddNewPayshapAccount()">
              ←
            </div>
            <div class="section-title">
              New Bank Account
            </div>
            <div class="search-box">
              <input class="search-input"
                    placeholder="Search bank"
                    [(ngModel)]="bankSearchInput"
                      (ngModelChange)="filterBanks()">
              <span class="search-icon">⌕</span>
            </div>
            <div class="bank-scroll">
              <div class="table-list">
                <div class="category-option" *ngFor="let p of filteredBanks"
                  [class.selected]="selectedBank === p"
                  (click)="selectBank(p)">
                  <div class="payment-option-left">
                    <span>{{ p.name }}</span>
                  </div>
                  <div class="tx-icon">
                      <img [src]="'assets/images/' + p.logo"
                          class="tx-img">
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          <div *ngIf="showNewBankDetails">
            <div class="back-btn" (click)="return('showBanks')">
              ←
            </div>
            <div class="section-title">
              New Bank Account
            </div>
            <div class="field">
              <label class="field-label">Bank</label>
              <div class="input-with-icon">
                <input
                  class="input"
                  [value]="selectedBank?.name"
                  readonly>
                <img
                  *ngIf="selectedBank"
                  [src]="'assets/images/' + selectedBank.logo"
                  class="bank-logo">
              </div>
            </div>
            <div class="field">
              <label class="field-label">Branch Code</label>
              <input class="input" placeholder="{{bankBranchCode}}" readonly>
            </div>
            <!-- ACCOUNT NUMBER -->
            <div class="field">
              <label class="field-label">Account Number</label>
              <input
                class="input"
                type="text"
                inputmode="numeric"
                maxlength="20"
                placeholder="Enter account number"
                [(ngModel)]="newAccountNumber"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onAccountNumberInput($event)">
              <div class="validation-message" *ngIf="newAccountNumberValidationMessage">
                {{newAccountNumberValidationMessage}}
              </div>   
              <label class="save-beneficiary">
                <input type="checkbox" [(ngModel)]="savePayshapAccount">
                Save bank account
              </label>
            </div>

            <!-- BUTTONS -->
            <div class="btns">
              <button class="set-authorization-btn"
                (click)="addNewPayshapAccount()"
                [disabled]="isLoading || !newAccountNumber || !accountNumberValid">
                <span *ngIf="!isLoading">Add</span>
                <span *ngIf="isLoading" class="spinner"></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--  TRANSACTION SUMMARY -->
      <div *ngIf="showTransactionSummary">
        <div class="back-btn" (click)="return('beneficiariesOrPayshapAccounts')">
          ←
        </div>
        <div class="summary-table">
          <div class="grey-label">
              Amount
          </div>
          <!-- limits -->
          <div class="limits" *ngIf="showAmountLimits">
            <div>{{dailyLimit}}</div>
            <div>{{monthlyLimit}}</div>
          </div>
          <div class="amount-box">
            <div class="currency">R</div>
            <input
                class="amount-input"
                type="text"
                inputmode="numeric"
                maxlength="6"
                placeholder="Enter amount"
                [(ngModel)]="amount"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onAmountInput();">
          </div>
          <div class="validation-message" *ngIf="amountValidationMessage">
            <div>{{amountValidationMessage}}</div>
          </div>
          <div class="grey-label">
            Transaction Summary
          </div>
          <div class="transactionSummary-card">
            <div class="detail-row" *ngIf="transactionTypeSummary">
              <div class="label">Transaction Type</div>
              <div class="colon"></div>
              <div class="value">{{transactionTypeSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="paymentMethodSummary">
              <div class="label">Payment Method</div>
              <div class="colon"></div>
              <div class="value">{{paymentMethodSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="beneficiarySummary">
              <div class="label">Beneficiary</div>
              <div class="colon"></div>
              <div class="value">{{beneficiarySummary}}</div>
            </div>
            <div class="detail-row" *ngIf="payshapAccountSummary">
              <div class="label">Bank Account</div>
              <div class="colon"></div>
              <div class="value">{{payshapAccountSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="userAmountSummary">
              <div class="label">Amount</div>
              <div class="colon"></div>
              <div class="value">{{userAmountSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="serviceFeeSummary">
              <div class="label">Service Fee</div>
              <div class="colon"></div>
              <div class="value">{{serviceFeeSummary}}</div>
            </div>
            <div class="detail-row" *ngIf="totalAmountToPaySummary">
              <div class="totalAmountToPay-card" >
                <div class="payment-option-left">
                  <span>{{ totalAmountToPayDescription }}</span>
                </div>
                <div class="colon"></div>
                  <span
                  class="totalAmount-span"
                  [ngClass]="{
                    'amount-valid': amountValid,
                    'amount-invalid': !amountValid
                  }">
                  {{ totalAmountToPaySummary }}
                </span>
              </div>
            </div>
          </div>
        <!-- BUTTONS -->
          <div class="authorize-btns" *ngIf="showAuthorizeButton">
            <button class="authorize-btn"
              (click)="AuthorizeTransaction()"
              [disabled]="!amount || 
                          amount <= 0 || 
                          amount < minAmount || 
                          amount > maxAmount || 
                          totalAmountToPay > walletBalance || 
                          amount>totalAmountToPay">
                          Authorize
            </button>
          </div>
        </div>

        <!-- AUTHORIZE POPUP -->
        <div class="overlay" *ngIf="showAuthorizePopup">
          <div class="alert-modal">
            <div class="section-title">
              Authorize Transaction
            </div>
            <p class="pin-text">
              Enter your 4-digit PIN.
            </p>
            <div class="pin-warning-text"  *ngIf="authorizationPinValidationMessage">
              {{authorizationPinValidationMessage}}
            </div>
            <div class="pin-wrapper">
              <input
                #pinInput
                class="hidden-pin-input"
                type="password"
                inputmode="numeric"
                maxlength="4"
                autocomplete="one-time-code"
                [(ngModel)]="authorizationPin"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onPinChange($event)">

              <div class="pin-wrapper">
                <!-- Hidden input -->
              <input
                #pinInput
                class="hidden-pin-input"
                type="password"
                inputmode="numeric"
                maxlength="4"
                autocomplete="one-time-code"
                [(ngModel)]="authorizationPin"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onPinChange($event)">

                <!-- Click anywhere to focus -->
                <div class="pin-display" (click)="pinInput.focus()">
                  <div class="pin-circle"
                      [class.filled]="authorizationPin.length > 0"
                      [class.active]="authorizationPin.length === 0">
                    {{ authorizationPin.length > 0 ? '•' : '' }}
                  </div>

                  <div class="pin-circle"
                      [class.filled]="authorizationPin.length > 1"
                      [class.active]="authorizationPin.length === 1">
                    {{ authorizationPin.length > 1 ? '•' : '' }}
                  </div>

                  <div class="pin-circle"
                      [class.filled]="authorizationPin.length > 2"
                      [class.active]="authorizationPin.length === 2">
                    {{ authorizationPin.length > 2 ? '•' : '' }}
                  </div>

                  <div class="pin-circle"
                      [class.filled]="authorizationPin.length > 3"
                      [class.active]="authorizationPin.length === 3">
                    {{ authorizationPin.length > 3 ? '•' : '' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="btns" *ngIf="!isLoading">
              <button
                class="cancel"
                (click)="closeAuthorizePopup()">
                Cancel
              </button>
              <button
                class="primary"
                [disabled]="authorizationPin.length !== 4"
                (click)="confirmAuthorization()">
                Authorize
              </button>
            </div>
            <div class="spinner-container" *ngIf="isLoading">
              <span class="spinner"></span>
            </div>
        </div>
      </div>
    </div>

    <div class="overlay" *ngIf="showErrorPopup">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Ok
          </button>
        </div>
      </div>
    </div>

    <div class="overlay" *ngIf="showTempPopUp">
      <div class="alert-modal">
        <p class="pin-text">
            {{ message  }}
        </p>
      </div>
    </div>
  `
})
export class PayComponent{
  sessionToken = '';
  userId = '';
  whatsAppUrl = environment.whatsapp_url;
  isLoading = false;
  isLoadingPageContent = true;
  showPageContent = false;
  showErrorPopup = false;
  errorMessage = '';
  paymentMethods: any[] = [];
  contacts: any[] = [];
  banks: any[] = [];
  beneficiaries: any[] = [];
  beneficiariesWithWalletyAccounts: any[] = [];
  filteredBanks = [...this.banks];
  payshapAccounts: any[] = [];
  filteredPayshapAccounts: any[] = [];
  walletBalance = 0;
  userNumber = '';
  userDisplayNumber = '';

  constructor(private router: Router,
                      private sessionService: SessionService,
                      private payService: PayService,
                      private payshapService: ContactPayshapAccountService,
                      private contactService: ContactService) {}
                      
  ngOnInit() {
    this.sessionToken = this.sessionService.getSession();
    if (!this.sessionToken) {
      this.errorMessage = 'Request failed, please reload page and try again.';
      this.showErrorPopup = true;
     
      return;
    }
    this.walletBalance = this.sessionService.getWalletBalance();
    this.getPayData();
  }
  getPayData() {
    this.payService
    .getPayData(this.sessionToken)
    .subscribe({
        next: response => {
          console.log(response);
          this.paymentMethods = response.payMethods.$values;
          this.banks =  response.banks.$values;
          this.beneficiaries =  response.beneficiaries.$values;
          this.beneficiariesWithWalletyAccounts =  response.beneficiariesWithWalletyAccount.$values;
          this.filteredBanks = [...this.banks];
          this.userNumber = response.userNumber;
          this.userDisplayNumber = response.userDisplayNumber;
          this.payshapAccounts =  response.payshapAccounts.$values;

          this.isLoadingPageContent = false;
           this.showPageContent = true;
        },
        error: err => {
          if (err.status === 401 || err.status === 404) {
            this.userId = this.sessionService.getUserId();
            this.router.navigateByUrl(
              '/Login/' + this.userId,
              { replaceUrl: true }
            );
            return;
          }
          this.errorMessage = err.error?.message ?? 'Unable to load page.';
          this.showErrorPopup = true;
          this.isLoadingPageContent = false;
        }
      },
    );
  }
 // =====================================================
  // PAYMENT OPTIONS
  // =====================================================
  showPaymentMethods = true;
  selectedPaymentMethod:any = null;
  paymentMethodHeader = '';
  selectPaymentMethod(paymentMethod:any){
    this.searchInput = '';
    this.amountValidationMessage = '';
    this.selectedPaymentMethod = paymentMethod;
    this.showPaymentMethods = false;
    this.showBeneficiarySection = true;
    this.paymentMethodHeader = this.selectedPaymentMethod.name
    this.transactionTypeSummary = 'Payment';

    if(this.paymentMethodHeader == 'Wallet'){
      this.transactionTypeSummary = 'Wallet transfer';
      this.contacts = this.beneficiariesWithWalletyAccounts;
    }
    else{
      this.contacts = this.beneficiaries;
    }
    this.minAmount = this.selectedPaymentMethod.minAmount;
    this.maxAmount = this.selectedPaymentMethod.maxAmount;
    this.paymentMethodSummary = paymentMethod.name;
  }
  // =====================================================
  // CONTACT
  // =====================================================
  newContactName = '';
  newContactNumber = '';
  newContactFormatedNumber = '';
  newContactDisplayNumber = '';
  contactNameValidationMessage = '';
  contactWhatsappNumberValidationMessage = '';
  addNewContactSectionTopHeading = '';
  showAddNewContact = false;
  selectedContact:any = null;
  showBeneficiarySection = false;
  saveContact = false;
  whatsappNumberValid = false;

  selectContact(contact:any){
    console.log(this.payshapAccounts);
    this.amountValidationMessage = '';
    this.selectedContact = contact;
    this.showBeneficiarySection = false;
    this.beneficiarySummary = contact.name + ' ' + '('+ contact.displayNumber + ')';

    
  // Only accounts for the selected contact
  this.filteredPayshapAccounts = this.payshapAccounts.filter(
    account => account.contactId === contact.id
  );

    if(this.paymentMethodHeader == 'Payshap'){
      this.showPayshapSection = true;
    }
    else{
      this.showTransactionSummary = true;
      if(this.paymentMethodHeader == 'Wallet')
        this.maxAmount = this.selectedContact.maxTransferAmount;
    }
    if(this.selectedPaymentMethod.hasLimits){
      this.showAmountLimits = true;
      if(this.selectedPaymentMethod.dailyLimit){
        this.dailyLimit = `Daily limit: R${this.selectedPaymentMethod.dailyLimit}`;
      }
      if(this.selectedPaymentMethod.monthlyLimit){
        
        this.monthlyLimit = `Monthly limit: R${this.selectedPaymentMethod.monthlyLimit}`;
      }
    }
    else{
      this.showAmountLimits = false;
      this.dailyLimit = null;
      this.monthlyLimit = null;
    }
  }
  filteredContacts() {
    let contacts = this.contacts;
    const search = this.searchInput.toLowerCase();
    return contacts.filter(x =>
      x.name.toLowerCase().includes(search) ||
      x.number.toLowerCase().includes(search) ||
      x.displayNumber.toLowerCase().includes(search)
    );
  }
  onAddNewContact(){
    this.showAddNewContact = true;
    this.showPayshapSection = false;
  }
  closeAddNewContact(){
    this.showAddNewContact = false;
    this.newContactName = '';
    this.newContactNumber = '';
    this.contactNameValidationMessage = '';
    this.contactWhatsappNumberValidationMessage = '';
  }
  onNewContactPhoneInput(){
    const validation =this.validatePhoneNumber();
      if(this.newContactNumber){
        if(!validation.isValid){
            this.contactWhatsappNumberValidationMessage = validation.message;
            this.whatsappNumberValid = false;
          }
          else{
            this.contactWhatsappNumberValidationMessage = '';
            this.whatsappNumberValid = true;
          }
      }
      else
        this.whatsappNumberValid = false;
  }
  addNewContact(){
    let hasError = false;
    this.contactNameValidationMessage = '';
    this.contactWhatsappNumberValidationMessage = '';

    // NAME
    if(!this.newContactName.trim()){
      this.contactNameValidationMessage = 'Name is required';
      hasError = true;
    }
    // WHATSAPP NUMBER
    if(!this.newContactNumber.trim()){
      this.contactWhatsappNumberValidationMessage = 'WhatsApp number is required';
      hasError = true;
    }
    else{
      const validation =this.validatePhoneNumber();
      if(!validation.isValid){
        this.contactWhatsappNumberValidationMessage = validation.message;
        hasError = true;
      }
    }      
    if(hasError){
      return;
    }
    this.beneficiarySummary = this.newContactName + ' ' + '('+ this.newContactNumber + ')';
    
    if(this.saveContact){
      this.isLoading = true;
      this.contactService
      .postContact(this.sessionToken,
                this.newContactName,
                this.newContactFormatedNumber, 
                this.newContactDisplayNumber, 
                'Pay')
      .pipe(
            finalize(() => this.isLoading = false)
          )
      .subscribe({
          next: response => {
            this.beneficiaries = response.activeContacts.$values;
            this.beneficiariesWithWalletyAccounts = response.contactsWithWalletyAccounts.$values;
            

            if(this.selectedPaymentMethod.name === 'Wallet')
              this.contacts = this.beneficiariesWithWalletyAccounts;
            else
              this.contacts = this.beneficiaries;

            this.selectContact(response.newContact);
            return;
          },
          error: err => {
             if (err.status === 401 || err.status === 404) {
              this.userId = this.sessionService.getUserId();
              this.router.navigateByUrl(
                '/Login/' + this.userId,
                { replaceUrl: true }
              );
              return;
            }
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
            return;
          }
        },
      );
    }
    else{
      this.showBeneficiarySection = false;
      if(this.paymentMethodHeader == 'Payshap'){
        this.showPayshapSection = true;
      }
      else{
        this.showTransactionSummary = true;
      }
    }
  }
  validatePhoneNumber(){
    let mobileRegexPattern = /^(0|\+27|27)[5-8][0-9][0-9]{7}$/;
    let phoneNumber = this.newContactNumber.trim().replace(/\s+/g, '');
    if(!mobileRegexPattern.test(phoneNumber)){
      return {
        isValid:false,
        message:'Invalid WhatsApp number'
      };
    }
    phoneNumber = phoneNumber.replace(/\D/g,'');// REMOVE NON NUMBERS
    if(phoneNumber.startsWith('0')){// CONVERT 076... -> 276...
      phoneNumber = phoneNumber.substring(1);
      phoneNumber = '27' + phoneNumber;
    }
    if(phoneNumber == this.userNumber){
      return {
        isValid:false,
        message:'You cannot add your number as a contact'
      };
    }
    // DISPLAY FORMAT
    let displayNumber = '0' + phoneNumber.substring(2);
    this.newContactFormatedNumber = phoneNumber;
    this.newContactDisplayNumber = displayNumber;
    return {
      isValid:true,
      message:'',
      formattedNumber:phoneNumber,
      displayNumber:displayNumber
    };
  }
  // =====================================================
  // PAYSHAP
  // =====================================================
  selectedBank:any = null;
  selectedPayshapAccount:any = null;
  bankValidationMessage = '';
  bankSearchInput = '';
  newAccountNumberValidationMessage = '';
  newAccountNumber = '';
  savePayshapAccount = false;

  showAddNewPayshapAccount = false;
  showActivePayshapAccounts = true;
  showPayshapAccountInfoOptions = false;
  showPayshapSection = false;
  showNewBankDetails = false;
  showSelectBank = true;
  bankBranchCode = '';
  accountNumberValid = false;

  filterBanks(){
    this.selectedBank = null;
    const search =
      (this.bankSearchInput || '')
        .toString().toLowerCase();

    this.filteredBanks =
      this.banks.filter(x =>
        x.name.toLowerCase().includes(search)
      );
  }
 selectBank(bank:any){
    this.selectedBank = bank;
    this.showNewBankDetails = true;
    this.showSelectBank = false;
    this.bankBranchCode = bank.branchCode;
  }
  selectPayshapAccount(account:any){
    this.searchInput = '';
    this.amountValidationMessage = '';
    this.selectedPayshapAccount = account;
    this.showPayshapSection = false;
    this.payshapAccountSummary = account.bankName + ' ' + '('+ account.accountNumber + ')';
    this.showTransactionSummary = true;

    if(this.selectedPaymentMethod.hasLimits){
      this.showAmountLimits = true;
      if(this.selectedPaymentMethod.dailyLimit){
        this.dailyLimit = `Daily limit: R${this.selectedPaymentMethod.dailyLimit}`;
      }
      if(this.selectedPaymentMethod.monthlyLimit){
        
        this.monthlyLimit = `Monthly limit: R${this.selectedPaymentMethod.monthlyLimit}`;
      }
    }
    else{
      this.showAmountLimits = false;
      this.dailyLimit = null;
      this.monthlyLimit = null;
    }
  }

  onAddNewPayshapAccount(){
    this.showAddNewPayshapAccount = true;
    this.bankBranchCode = '';
    this.newAccountNumber = '';
    this.selectedBank = null;
    this.showNewBankDetails  = false;
    this.showSelectBank = true;
  }
  closeAddNewPayshapAccount(){
    this.showAddNewPayshapAccount = false;
    this.selectedBank = null;
    this.bankSearchInput = '';
    this.newAccountNumber = '';
    this.filteredBanks = [...this.banks];
    this.newAccountNumberValidationMessage = '';
    this.bankValidationMessage = '';
    this.bankBranchCode = '';
  }
  onAccountNumberInput(value: string) {
  this.newAccountNumber = value.replace(/\D/g, '').slice(0, 20);
   const validation =this.validateAccountNumber();
    if(this.newAccountNumber){
      if(!validation.isValid){
          this.newAccountNumberValidationMessage = validation.message;
          this.accountNumberValid = false;
        }
        else{
          this.newAccountNumberValidationMessage = '';
          this.accountNumberValid = true;
        }
    }
    else
       this.accountNumberValid = false;
  }
  validateAccountNumber(){
    let accountNumber = this.newAccountNumber.trim().replace(/\s+/g, '');
    // ONLY NUMBERS
    if(!/^\d+$/.test(accountNumber)){

      return {
        isValid:false,
        message:'Account number must contain only numbers'
      };
    }
    // LENGTH CHECK
    if(accountNumber.length < 6 ||
      accountNumber.length > 20){
      return {
        isValid:false,
        message:'Account number must be between 6 and 20 digits'
      };
    }
    // VALID
    return {
      isValid:true,
      message:''
    };
  }
  addNewPayshapAccount(){
    let hasError = false;
    this.bankValidationMessage = '';
    this.newAccountNumberValidationMessage = '';

    // BANK
    if(!this.selectedBank){
      this.bankValidationMessage = 'Bank is required';
      hasError = true;
    }
    // ACCOUNT NUMBER
    if(!this.newAccountNumber.trim()){
      this.newAccountNumberValidationMessage = 'Account number is required';
      hasError = true;
    }
    else{
      const validation =this.validateAccountNumber();
      if(!validation.isValid){
        this.newAccountNumberValidationMessage = validation.message;
        hasError = true;
      }
    }      

    if(hasError){
      return;
    }

    //Send request
    this.payshapAccountSummary = this.selectedBank.name + ' ' + '('+ this.newAccountNumber + ')';

    if(this.savePayshapAccount){
      this.isLoading = true;
      this.payshapService
      .postPayshapAccount(this.sessionToken,
                this.selectedContact.id,
                this.selectedBank?.id,
                this.newAccountNumber, 
                'Pay')
      .pipe(
            finalize(() => this.isLoading = false)
          )
      .subscribe({
          next: response => {
            const newAccount = response.newPayshapAccount;

            this.payshapAccounts.push(newAccount);

            if (this.selectedContact &&
                newAccount.contactId === this.selectedContact.id) {
              this.filteredPayshapAccounts.push(newAccount);
            }

            this.selectPayshapAccount(newAccount);
            return;
          },
          error: err => {
             if (err.status === 401 || err.status === 404) {
              this.userId = this.sessionService.getUserId();
              this.router.navigateByUrl(
                '/Login/' + this.userId,
                { replaceUrl: true }
              );
              return;
            }
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
            return;
          }
        },
      );
    }
    else{
      this.showPayshapSection = false;
      this.showTransactionSummary = true;
    }
  }
   // =====================================================
  // TRANSACTION SUMMARY
  // =====================================================
  showTransactionSummary = false;
  transactionTypeSummary = '';
  paymentMethodSummary = '';
  beneficiarySummary = '';
  payshapAccountSummary = '';
  userAmountSummary = '';
  serviceFeeSummary = '';
  totalAmountToPaySummary = '';
  // =====================================================
  // AUTHORIZATION
  // =====================================================
  showAuthorizePopup = false;
  authorizationPin = '';
  showAuthorizeButton = true;
  authorizationPinValidationMessage = '';
  showTempPopUp = false;
  message = '';

  onPinChange(value: string): void {
    this.authorizationPin = value.replace(/\D/g, '').slice(0, 4);
  }
   AuthorizeTransaction() {
    this.showAuthorizeButton = false;
    this.authorizationPin = '';
    this.showAuthorizePopup = true;
  }
  closeAuthorizePopup() {
    this.showAuthorizeButton = true;
    this.showAuthorizePopup = false;
    this.authorizationPin = '';
  }
  confirmAuthorization() {
    this.isLoading = true;
    this.payService
    .postPay(this.sessionToken,
            this.authorizationPin,
            this.selectedPaymentMethod.id,
            this.selectedContact?.id ?? '',
            this.newContactName,
            this.newContactFormatedNumber, 
            this.newContactDisplayNumber, 
            this.serviceFeeId, 
            this.selectedPayshapAccount?.id ?? '',
            this.selectedBank?.id ?? '',
            this.newAccountNumber,
            this.amount, 
            this.serviceFee, 
            this.totalAmountToPay)
    .pipe(
          finalize(() => this.isLoading = false)
        )
    .subscribe({
        next: response => {
          this.authorizationPin = '';
          this.showAuthorizePopup = false;

          if (response.status === 201) {
            this.message = response.body.message;
            this.showTempPopUp = true;
            setTimeout(() => {
              this.showTempPopUp = false;
              window.location.href = this.whatsAppUrl;
            }, 3000);
          }else{
            window.location.href = this.whatsAppUrl;
          }
        },
        error: err => {
          this.authorizationPin = '';
           if (err.status === 401 || err.status === 404) {
            this.showAuthorizePopup = false;
              this.userId = this.sessionService.getUserId();
              this.router.navigateByUrl(
                '/Login/' + this.userId,
                { replaceUrl: true }
              );
              return;
            }
            if (err.status === 501) {
              this.authorizationPinValidationMessage = err.error?.message;
              return;
            }
            if (err.status === 402) {
              this.showAuthorizePopup = false;
              this.showErrorPopup = true;
              this.amountValidationMessage = err.error?.message;
              return;
            }
            else{
              this.showAuthorizePopup = false;
              this.errorMessage = err.error?.message ?? 'Unable to load page.';
              this.showErrorPopup = true;
            }
        }
      },
    );
  }
  // =====================================================
  // AMOUNT
  // =====================================================
  totalAmountToPayDescription = '';
  amountValidationMessage = '';
  amount: number | null = null;
  totalAmountToPay: number | null = null;
  serviceFee: number | null = null;
  dailyLimit = '';
  monthlyLimit = '';
  showAmountLimits = false;
  minAmount = 0;
  maxAmount = 0;
  serviceFeeId = '';
  amountValid = false;

  onAmountInput(){
    this.amountValidationMessage = '';
    this.amountValid = false;

    if (this.amount == null) {
      this.userAmountSummary = '';
      this.totalAmountToPay = null;
      this.totalAmountToPaySummary = '';
      this.serviceFee = null;
      this.serviceFeeSummary = '';
      return;
    }
    else if (this.amount < this.minAmount) {
    this.amountValidationMessage = `Minimum amount is R${this.minAmount}`;
      this.userAmountSummary = '';
      this.totalAmountToPay = null;
      this.totalAmountToPaySummary = '';
      this.serviceFee = null;
      this.serviceFeeSummary = '';
    return;
    }
    else if (this.amount > this.maxAmount) {
      this.amountValidationMessage = `Maximum amount is R${this.maxAmount}`;
        this.userAmountSummary = '';
      this.totalAmountToPay = null;
      this.totalAmountToPaySummary = '';
      this.serviceFee = null;
      this.serviceFeeSummary = '';
      return;
    }
    else{
      this.totalAmountToPay = this.amount;
     // if(this.selectedPaymentMethod.hasServiceFee){
        this.totalAmountToPayDescription = 'Total Amount';
        this.userAmountSummary = `R${this.amount}`;
        
        this.serviceFee = this.getServiceFee(this.amount,this.selectedPaymentMethod);
        this.totalAmountToPay = Math.round((Number(this.amount) + Number(this.serviceFee)) * 100) / 100;
        this.serviceFeeSummary = `R${this.serviceFee.toFixed(2)}`;
      //}
      // else{
      //   this.totalAmountToPayDescription = 'Amount';
      //   this.serviceFee = null;
      //   this.userAmountSummary = '';
      //   this.serviceFeeSummary = '';
      // }
      this.totalAmountToPaySummary = `R${this.totalAmountToPay.toFixed(2)}`;
      if (this.totalAmountToPay > this.walletBalance) {
        if (this.totalAmountToPay == this.amount) {
          this.amountValidationMessage = `Insufficient funds to cover amount`;
        }
        else{
          this.amountValidationMessage = `Insufficient funds to cover amount plus fees`;
        }
        return;
      }
      // Amount is valid
      this.amountValid = true;
    }
  }
  getServiceFee(amount: number, method: any): number {
    const tier = this.getServiceFeeTier(amount, method);
    if (!tier) {
      return 0;
    }
    this.serviceFeeId = tier.id;
    if (tier.isFixedFeeType) {
      return tier.value;
    }

     if(tier.percentageCharge)
      return tier.value + (amount * (tier.percentageCharge / 100))
    else
       return amount * tier.value / 100;
  }
  getServiceFeeTier(amount: number, method: any) {
    if (!method?.serviceFees?.$values.length) {
      return null;
    }
    // Only one fee? Use it for every amount.
    if (method.serviceFees.$values.length === 1) {
      return method.serviceFees.$values[0];
    }
    return method.serviceFees.$values.find((x: any) =>
      amount >= x.min && amount <= x.max
    );
  }
  // =====================================================
  // COMMON
  // =====================================================
  searchInput = '';

  closeErrorPopup(): void {
    this.showErrorPopup = false;
    this.showAuthorizeButton = true;
  }
  return(view: string){
    this.searchInput = '';
    this.amountValidationMessage = '';
    if(view === 'paymentMethods'){
      this.selectedPaymentMethod = null;
      this.showBeneficiarySection = false;
      this.showPayshapSection = false;
      this.showPaymentMethods  = true;
      this.transactionTypeSummary = '';
    }
    else if(view === 'beneficiariesOrPayshapAccounts'){
      this.amount = null;
      this.userAmountSummary = '';
      this.serviceFeeSummary = '';
      this.totalAmountToPaySummary = '';
      this.showTransactionSummary = false;
        
      if(this.paymentMethodHeader == 'Payshap'){
        this.selectedPayshapAccount = null;
        this.payshapAccountSummary = '';
        this.showPayshapSection = true;

        if(this.saveContact){
          this.showAddNewContact = false;
          this.saveContact = false;
          this.newContactName = '';
          this.newContactNumber = '';
        }
         if(this.savePayshapAccount){
          this.showAddNewPayshapAccount = false;
          this.savePayshapAccount = false;
          this.selectedBank = null;
          this.newAccountNumber = '';
        }
        
      }
      else{
        this.selectedContact = null;
        this.beneficiarySummary = '';
        this.showPayshapSection = false;
        this.showBeneficiarySection = true;

        if(this.saveContact){
          this.showAddNewContact = false;
          this.saveContact = false;
        }
      }
    }
    else if(view === 'beneficiaries'){
      this.selectedContact = null;
      this.amount = null;
      this.beneficiarySummary = '';
      this.userAmountSummary = '';
      this.serviceFeeSummary = '';
      this.totalAmountToPaySummary = '';

      this.showTransactionSummary = false;
      this.showPayshapSection = false;
      this.showBeneficiarySection = true;

        if(this.saveContact){
        this.showAddNewContact = false;
        this.saveContact = false;
      }
    }
    else if(view === 'showBanks'){
      this.selectedBank = null;
      this.bankBranchCode = '';
      this.newAccountNumber = '';
      this.showNewBankDetails  = false;
      this.showSelectBank = true;
    }
  }
   allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End'
    ];

    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Block everything except digits
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
}